import { Container, Col, Row } from "reactstrap";
import * as BlogPostQL from "queries/blog-post";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import BlogPostSchema from "@common/schema/blog-post/public";
import * as widgets from "widgets/register";
import * as Section from "@repoflow/components/section";

// `status` is the column that matters: it is what tells `published` from
// `changed` — the draft has edits the page does not show — which gen-2's two
// listings (posts, published) could not say without opening both.
export const LIST_FIELDS = {
  "/Public/BlogPost": {
    fields: ["title", "slug", "status", "date", "updatedAt"],
  },
};

export const Sidebar = () => null;
export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>
      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Write a post
          </Link>
        </Col>
      </Row>
      <div className="mt-4"></div>
      <List
        path={"viewer.account.sites.get.blog.posts"}
        query={BlogPostQL.list}
        variables={{ siteId: params.siteId }}
        schema={BlogPostSchema}
        widgets={widgets}
        target={{ $ref: "/Public/BlogPost" }}
        empty={"No posts yet."}
        config={LIST_FIELDS}
        content={({ item: { postId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${postId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
